import { z } from 'zod';

export type CustomerAppPointsStatus = z.infer<typeof CustomerAppPointsStatus>;
export type CustomerAppPoints = z.infer<typeof CustomerAppPoints>;

export const CustomerAppPointsStatus = z.object({
    /** The raw value of the status as it comes from the customer app backend. */
    value: z.string().nullish(),
    /** A user friendly display name of the status. */
    displayName: z.string().nullish(),
    /** Gets the date and time until when the status is valid. After this date, the status might be reset or changed. */
    validTo: z.coerce.date().nullish(),
    /** The number of points that are required to reach the next status. */
    pointsToNextStatus: z.number().nullish(),
});

export const CustomerAppPoints = z.object({
    /** The source where the points come from. In most cases it will the the app. */
    source: z.string().nullish(),
    /** The value of the collected points. */
    value: z.number().nullish(),
    /** The status of the collected points. If not present, the customer app might not support this feature. */
    status: CustomerAppPointsStatus.nullish(),
});
